/**
 * 为el-dialog弹框增加拖拽功能
 * @param {*} el 指定dom
 * @param {*} binding 绑定对象
 * parent：父级选择器
 * callback：在可视区域内的回调函数
 */
let observeVisibility = {}
observeVisibility.install = function (Vue) {
  Vue.directive('observe-visibility', {
    inserted (el, binding) {
      try {
        const options = binding.value || {}
        const parentSelector = options.parent || '' // 父级选择器
        const callback = options.callback || (() => { }) // 在可视区域内的回调函数

        const parentEl = parentSelector
          ? el.closest(parentSelector)
          : el.parentElement
        // el = options.el ? el.querySelector(`${options.el}`) : el //可能未加载，可直接挂载在缩略图的div上
        if (!parentEl) {
          console.info(`Parent element not found for selector: ${parentSelector}`)
          return
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            // console.info(27, entry.intersectionRatio)
            if (entry.isIntersecting) { // el与parentEl是否交叉
              // if (!el._hasLoaded) {
              // el._hasLoaded = true
              callback(true)
              // }
            } else {
              callback(false)
            }
          })
        }, { root: parentEl, threshold: 0.1 })

        observer.observe(el)
        el._observer = observer
        // parentEl.addEventListener('scroll', debounce(() => handleScroll(el, parentEl, callback), 200))
        el._parentEl = parentEl
      } catch (error) {
        console.info('error observe-visibility inserted', error)
      }
    },
    unbind (el, binding) {
      try {
        const options = binding.value || {}
        const callback = options.callback || (() => { }) // 在可视区域内的回调函数
        callback(false)
        if (el._observer) {
          el._observer.disconnect()
          delete el._observer
        }
        if (el._parentEl) {
          // el._parentEl.removeEventListener('scroll', () => handleScroll(el, el._parentEl, null))
          delete el._parentEl
        }
      } catch (error) {
        console.info('error observe-visibility unbind', error)
      }
    }
  })
}

// 辅助函数：判断元素是否在父级的可视区域内并执行回调
// const handleScroll = (el, parentEl, callback) => {
//   // if (isElementInViewport(el, parentEl) && !el._hasLoaded) {
//   //   el._hasLoaded = true
//   //   callback && callback()
//   // }
//   if (isElementInViewport(el, parentEl)) {
//     // el._hasLoaded = true
//     callback && callback(true)
//   } else {
//     callback && callback(false)
//   }
// }

// function isElementInViewport (el, parentEl) {
//   const rect = el.getBoundingClientRect()
//   const parentRect = parentEl.getBoundingClientRect()
//   return (
//     rect.top >= parentRect.top &&
//     rect.left >= parentRect.left &&
//     rect.bottom <= parentRect.bottom &&
//     rect.right <= parentRect.right
//   )
// }

// function debounce (func, wait) {
//   let timeout
//   return function (...args) {
//     const context = this
//     clearTimeout(timeout)
//     timeout = setTimeout(() => func.apply(context, args), wait)
//   }
// }

export default observeVisibility
